import { render, staticRenderFns } from "./opportunity.vue?vue&type=template&id=3c87dd76&scoped=true"
import script from "./opportunity.vue?vue&type=script&lang=js"
export * from "./opportunity.vue?vue&type=script&lang=js"
import style0 from "./opportunity.vue?vue&type=style&index=0&id=3c87dd76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c87dd76",
  null
  
)

export default component.exports